import messages from './cmsSchedule.json' with { type: 'json' };

export const cmsScheduleFi: Readonly<typeof messages> = messages;
